import { useEffect, useRef, useState } from "react";
import styles from "./index.module.css";
import CopyIcon from "./CopyIcon";
import CloseIcon from "./CloseIcon";

const formatHtmlToText = (root) => {
  let result = "";

  const walk = (node, indent = 0) => {
    if (node.nodeType === Node.TEXT_NODE) {
      result += node.textContent;
      return;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) return;

    const tag = node.tagName.toLowerCase();

    if (tag === "br") {
      result += "\n";
      return;
    }

    if (tag === "p") {
      node.childNodes.forEach((child) => walk(child, indent));
      result += "\n\n";
      return;
    }

    if (tag === "ul") {
      result += "\n";
      node.childNodes.forEach((child) => walk(child, indent));
      result += "\n";
      return;
    }

    if (tag === "ol") {
      let index = 1;

      result += "\n";

      node.childNodes.forEach((child) => {
        if (child.tagName?.toLowerCase() === "li") {
          result += `${index}. `;
          walk(child, indent + 1);
          result += "\n";
          index++;
        }
      });

      result += "\n";
      return;
    }

    if (tag === "li") {
      const isUnordered = node.parentNode?.tagName?.toLowerCase() === "ul";

      if (isUnordered) {
        result += `${"  ".repeat(indent)}- `;
      }

      node.childNodes.forEach((child) => walk(child, indent));

      result += "\n";
      return;
    }

    node.childNodes.forEach((child) => walk(child, indent));
  };

  walk(root);

  return result
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
};

export default function QualificationDetailModal({
  open,
  title = "Qualification Details",
  descriptionHtml = "",
  noteHtml = "",
  onClose,
}) {
  const contentRef = useRef(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!open) {
      setCopied(false);
    }
  }, [open]);

  if (!open) return null;

  const handleCopy = async () => {
    if (!contentRef.current) return;

    const descriptionEl = contentRef.current.querySelector(
      `.${styles.htmlContent}`
    );

    if (!descriptionEl) return;

    const text = formatHtmlToText(descriptionEl);

    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 1500);
    } catch (error) {
      console.error("Copy failed", error);
    }
  };

  const hasDescription = Boolean(descriptionHtml?.trim());
  const hasNote = Boolean(noteHtml?.trim());

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>

          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close qualification details"
          >
            <CloseIcon />
          </button>
        </div>

        <div className={styles.copyRow}>
          <button
            type="button"
            className={styles.copyButton}
            onClick={handleCopy}
          >
            <span className={styles.copyIcon}>
              <CopyIcon />
            </span>
            {copied ? "Copied" : "Copy"}
          </button>
        </div>

        <div ref={contentRef} className={styles.contentCard}>
          {hasDescription ? (
            <div
              className={styles.htmlContent}
              dangerouslySetInnerHTML={{ __html: descriptionHtml }}
            />
          ) : (
            <div className={styles.emptyText}>
              No qualification details available.
            </div>
          )}

          {/* {hasNote ? (
            <div
              className={styles.noteContent}
              dangerouslySetInnerHTML={{ __html: noteHtml }}
            />
          ) : null} */}
        </div>
      </div>
    </div>
  );
}
